import { ContactFormFieldType, ContactFormField } from "../types"
import * as yup from "yup"

const baseField = (type: ContactFormFieldType) => {
  switch (type) {
    case "string":
      return yup.string()
    case "email":
      return yup.string().email()
    case "phone":
      return yup
        .string()
        .matches(
          /^\+(?:[0-9] ?){6,14}[0-9]$/,
          "Errore nel formato del numero di telefono"
        )
    case "textarea":
      return yup.string()
    case "checkbox":
      return yup.boolean().oneOf([true], "Devi accettare i termini")
    case "file":
      return yup.mixed().test("fileSize", "Il file non è presente", (value) => {
        if (value.length > 0) return true
        return false
      })
    case "select":
      return yup.string().required()
    case "province":
      return yup.string().required()
    case "role":
      return yup.string()
    default:
      return yup.mixed()
  }
}

export const generateYupSchema = (fields: ContactFormField[]) => {
  const yupSchemaObject = fields.reduce((acc, field) => {
    const { label } = field
    return {
      ...acc,
      [label]: field.required
        ? baseField(field.type).required(field.requiredErrorMessage)
        : baseField(field.type),
    }
  }, {})

  return yup.object().shape(yupSchemaObject)
}
